// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6f366bbc","337":"d13dd7a2","453":"3f2eb866","455":"20d6729d"}[chunkId] + ".chunk.js";
};